import * as React from 'react'
import './Cashier.scss'
import AmtInput from "../../components/AmtInput";
import { ActionType, cashierType, merchantInfoType, PRODUCTS, reducerStoreType } from "../../reducers/types";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { ChangeEvent } from "react";
import NumberPad, { keyItem } from "../../components/NumberPad";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import TransQrModal from "./TransQrModal";
import { toast } from "react-toastify";
import ScanQrModal from "./ScanQrModal";
import { Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from "react-intl";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  cashier: cashierType,
  scanQrModalOpen: boolean,
  transQrModalOpen: boolean,
  merchantInfo: merchantInfoType,
  intl: IntlShape,
}

interface IState {
  transQrOpen: boolean,
}

// const dealAmt = (prevAmt: string, amt: string): string => {
//     if (amt.length < prevAmt.length) {
//         // 删除字符
//         return amt
//     }
//     let last = amt.substr(amt.length - 1, 1)
//     if (last.match(/\d|\./g)) {
//         //新输入的是数字或小数点
//         if (prevAmt === '0' && last !== '.') {
//             return amt.substr(1)
//         }
//         // 在空的情况下输入., 变为0.
//         if (prevAmt === '' && last === '.') {
//             return '0' + last
//         }
//         // 如果已经有., 不能再输入.
//         if (prevAmt.indexOf('.') > -1 && last === '.') {
//             return amt.substr(0, amt.length - 1)
//         }
//         return amt
//     }
//     // 如果新输入不为数字或小数点，则不变
//     return prevAmt
// }

const calcFee = (amt: number, feeRate: number): number => {
  console.log(amt, feeRate)
  return (amt / (1 - feeRate)) - amt
}

class Cashier extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      transQrOpen: false,
    }
  }

  getFeeRate = () => {
    for (var i in this.props.merchantInfo.walletList) {
      if (this.props.merchantInfo.walletList[i].wallet === this.props.cashier.payChannel) {
        return this.props.merchantInfo.walletList[i].feeRate
      }
    }
  }
  getFee = (): string => {
    if (this.props.merchantInfo.feeType === 1) {
      // 用户承担手续费
      let feeRate = this.getFeeRate()
      if (feeRate) {
        let fee = calcFee(Number(this.props.cashier.amt), feeRate)
        if (this.props.merchantInfo.currency.toUpperCase() === 'JPY') {
          return fee.toFixed(0)
        } else {
          return fee.toFixed(2)
        }

      }
    }
    return ''
  }
  handleCurrencyChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.log(event.target.value)
    const value = event.target.value as string;

    // 获取选中货币对应的利率
    const selectedAccount = this.props.merchantInfo.accoutList.find(item => item.currency === value);
    const exchangeRate = selectedAccount ? selectedAccount.exchangeRate : 0;

    let payload = {
      ...this.props.cashier,
      checkcurr: value,
      exchangeRate: exchangeRate
    }
    this.props.dispatch({ type: 'CASHIER_CHANGE', payload })
  }
  handleAmtChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value
    // let amt = dealAmt(this.props.cashier.amt, value)
    if (this.props.cashier.checkcurr === 'JPY') {
      let reg = /^\+?[1-9][0-9]*$/
      if (reg.test(value)) {
        let amt = value
        this.props.dispatch({ type: 'CASHIER_CHANGE', payload: { amt } })
      }
      if (value === '') {
        let amt = value
        this.props.dispatch({ type: 'CASHIER_CHANGE', payload: { amt } })
      }
    } else {
      // 清除“数字”和“.”,“-”以外的字符
      value = value.replace(/[^\d.-]/g, "");
      // 验证第一个字符不是.
      value = value.replace(/^\./g, "");
      // 当存在连续的多个“.”时，只保留一个
      value = value.replace(/\.{2,}/g, ".");
      // 只保留第一个“.”，清除多余的“.”
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      // 当存在连续的多个“-”时，只保留一个
      value = value.replace(/\-{2,}/g, "-");
      // 只保留第一个“-”，清除多余的“-”
      value = value.replace("-", "$#$").replace(/\-/g, "").replace("$#$", "-");
      // 如果行首不是“-”，则不允许有“-”
      if (!(/^\-/.test(value))) {
        value = value.replace("-", "");
      }
      // 只能输入小数点后两位
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      let amt = value
      this.props.dispatch({ type: 'CASHIER_CHANGE', payload: { amt } })
    }
  }
  handleRemarkChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value
    let payload = {
      ...this.props.cashier,
      remark: value
    }
    this.props.dispatch({ type: 'CASHIER_CHANGE', payload })
  }
  handleNumberPadChange = (item: keyItem) => {
    let prevAmt = this.props.cashier.amt
    let value = ''
    if (item.action && item.action === 'delete') {
      value = prevAmt.substr(0, prevAmt.length - 1)
    } else {
      value = prevAmt + item.value
    }
    // let amt = dealAmt(this.props.cashier.amt, value)
    if (this.props.cashier.checkcurr === 'JPY') {
      let reg = /^\+?[1-9][0-9]*$/
      if (reg.test(value)) {
        let amt = value
        this.props.dispatch({ type: 'CASHIER_CHANGE', payload: { amt } })
      }
      if (value === '') {
        let amt = value
        this.props.dispatch({ type: 'CASHIER_CHANGE', payload: { amt } })
      }
    } else {
      // 清除“数字”和“.”,“-”以外的字符
      value = value.replace(/[^\d.-]/g, "");
      // 验证第一个字符不是.
      value = value.replace(/^\./g, "");
      // 当存在连续的多个“.”时，只保留一个
      value = value.replace(/\.{2,}/g, ".");
      // 只保留第一个“.”，清除多余的“.”
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      // 当存在连续的多个“-”时，只保留一个
      value = value.replace(/\-{2,}/g, "-");
      // 只保留第一个“-”，清除多余的“-”
      value = value.replace("-", "$#$").replace(/\-/g, "").replace("$#$", "-");
      // 如果行首不是“-”，则不允许有“-”
      if (!(/^\-/.test(value))) {
        value = value.replace("-", "");
      }
      // 只能输入小数点后两位
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      let amt = value
      this.props.dispatch({ type: 'CASHIER_CHANGE', payload: { amt } })
    }
  }
  handleTransQrClose = () => {
    this.props.dispatch({ type: 'CLOSE_TRANS_QR_MODAL', payload: undefined })
  }
  transQrOpen = () => {
    this.props.dispatch({ type: 'OPEN_TRANS_QR_MODAL', payload: undefined })
  }
  handleScanQrClose = () => {
    this.props.dispatch({ type: 'CLOSE_SCAN_QR_MODAL', payload: undefined })
  }
  checkOrderParam = () => {
    if (!this.props.cashier.amt) {
      toast.error(this.props.intl.formatMessage({ id: 'amtNotNull' }))
      return false
    }
    if (Number(this.props.cashier.amt) < 0.01 || (this.props.merchantInfo.currency.toUpperCase() === 'JPY' && Number(this.props.cashier.amt) < 1)) {
      toast.error(this.props.intl.formatMessage({ id: 'amtShouldBeInteger' }))
      return false
    }
    return true
  }
  genQr = () => {
    if (this.checkOrderParam()) {
      this.props.dispatch({
        type: 'CREATE_ORDER',
        payload: {
          orderType: 'transQr',
          data: {
            amt: this.props.cashier.amt,
            tradeSummary: this.props.cashier.remark,
            payChannel: this.props.cashier.payChannel,
            currency: this.props.cashier.checkcurr,
          }
        }
      })
      this.transQrOpen()
    }
  }

  scanQr = () => {
    if (this.checkOrderParam()) {
      this.props.dispatch({ type: 'OPEN_SCAN_QR_MODAL', payload: undefined })
    }
  }
  selectWallet = (wallet: string) => {
    let payload = {
      ...this.props.cashier,
      payChannel: wallet
    }
    this.props.dispatch({ type: 'CASHIER_CHANGE', payload })
  }

  getAmtAfterExchange = () => {
    let amt = Number(this.props.cashier.amt)
    let { markupRate, orgCurrency } = this.props.merchantInfo
    let exchangeRate = this.props.cashier.exchangeRate
    let realAmt = amt * exchangeRate * (1 + markupRate)
    if (orgCurrency.toUpperCase() === 'JPY') {
      return realAmt.toFixed(0)
    } else {
      return realAmt.toFixed(2)
    }
  }
  getExchangeRate = () => {
    return (this.props.cashier.exchangeRate * (1 + this.props.merchantInfo.markupRate)).toFixed(6)
  }
  public render() {
    let { walletList, feeType, exchangeFlag, orgCurrency, currency, productList, accoutList } = this.props.merchantInfo
    let fee = this.getFee()
    let { intl } = this.props
    return (
      <Grid item xs={12} md={6} lg={5} xl={4}>
        <div className="cashier">
          <div className="header">
            <h2>{intl.formatMessage({ id: 'cachierDesk' })}</h2>
          </div>
          <div className="container">
            <div className="amtContainer">
              <AmtInput
                currency={this.props.cashier.checkcurr}
                accoutList={accoutList}
                onChange={this.handleAmtChange}
                onCurrencyChange={this.handleCurrencyChange}
                val={this.props.cashier.amt} />
              {exchangeFlag ?
                <div className="exchangeRate">1{this.props.cashier.checkcurr} ≈ {this.getExchangeRate()}{orgCurrency}</div> : null}
            </div>
            {exchangeFlag === 1 ?
              <div className="tips">
                {intl.formatMessage({ id: 'collectAmt' })}({orgCurrency}): {this.getAmtAfterExchange()}
              </div> : null}
            {exchangeFlag === 0 && feeType === 1 && Number(fee) > 0 ?
              <div className="tips">{intl.formatMessage({ id: 'userBuyFee_checkout' })}：{currency} {fee}</div> : null}
            <input className="remarkInput"
              placeholder={intl.formatMessage({ id: 'remark' })}
              value={this.props.cashier.remark}
              onChange={this.handleRemarkChange} />
            {walletList.length > 1 ?
              <div className="wallets">
                {walletList.map((wallet, i) => {
                  return <span
                    className={`wallet ${this.props.cashier.payChannel === wallet.wallet ? 'selected' : ''}`}
                    key={`${wallet.wallet}-${i}`}
                    onClick={() => this.selectWallet(wallet.wallet)}>
                    {wallet.wallet}
                  </span>
                })}

              </div> : null}
            <NumberPad onChange={this.handleNumberPadChange} />
            <div className={`buttons ${productList.length === 1 ? 'one' : ''}`}>
              {productList.indexOf(PRODUCTS.TRANSACTION_CODE) > -1 ?
                <button className="transQr" onClick={this.genQr}>
                  <span className="icon icon-qrcode"></span>{intl.formatMessage({ id: 'genQr' })}
                </button> : null}
              {productList.indexOf(PRODUCTS.BARCODE) > -1 ?
                <button className="scanQr" onClick={this.scanQr}>
                  <span className="icon icon-scan"></span>{intl.formatMessage({ id: 'scanQr' })}
                </button> : null
              }
            </div>
          </div>
          <CustomDialog
            customWidth='500px'
            titleColor='primary'
            open={this.props.transQrModalOpen}
            handleClose={this.handleTransQrClose}
            title={intl.formatMessage({ id: 'collectQr' })}
            content={<TransQrModal fee={fee} />}
            showActions={false} />
          <CustomDialog
            titleColor='primary'
            open={this.props.scanQrModalOpen}
            handleClose={this.handleScanQrClose}
            title={this.props.intl.formatMessage({ id: 'scanQr' })}
            content={<ScanQrModal onClose={this.handleScanQrClose} />}
            showActions={false} />
        </div>
      </Grid>);
  }
}

export default injectIntl(connect((state: reducerStoreType, props) => {
  return {
    cashier: state.dashboard.cashier,
    scanQrModalOpen: state.dashboard.scanQr.modalOpen,
    transQrModalOpen: state.dashboard.transQr.modalOpen,
    merchantInfo: state.merchant.merchantInfo,

  }
})(Cashier))